module.exports = __webpack_public_path__ + "media/images/faces/female/10-4fdfa525259f45b5615e4577849b79ab.jpg";